import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import { invokeGetService,invokeV1GetService, handleSnackBar } from '../../../store/global/actions';
import { Grid, Typography, CircularProgress, Button, Tooltip, List, ListItem, ListItemIcon, ListItemText, IconButton,Paper } from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const AU = require('ansi_up');
const ansi_up = new AU.default();
const drawerWidth = 171;


const useStyles = makeStyles((theme) => ({
    search: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        marginLeft: '12px !important',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
        border: '1px solid #ccc',
    },
    filterDiv: {
        fontColour: '#ccc',
        height: '100%',
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
    },
    inputRoot: {
        color: 'inherit',
        border: '1px solid #ccc', // Add border to the input root
        borderRadius: theme.shape.borderRadius, // Add border radius
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
        display: 'flex',
        flexGrow: 1,
        borderRadius: theme.shape.borderRadius, // Add border radius
    },
    noResult: {
        margin: '10px 12px',
        fontColour: '#ccc',
        fontWeight: 400
    },
    filterBtn: {
        fontSize: 14,
        fontWeight: 600,
        textTransform: 'none',
        color: '#737373',
        focusRipple: 'none'
    },
    dropdownMenu: {
        marginTop: "34px",
    },
    dropdownMenuPaper: {
        borderRadius: "4px",
        border: "solid 1px #ccc",
        boxShadow: 'none'
    },
    topHeading: {
        marginTop: 4,
        marginBottom: 4,
        display: 'flex',
        justifyContent: 'space-between'
    },
    labelDivStyle: {
        marginTop: "15px",
    },
    terminateBtn: {
        marginTop: "15px",
        marginRight: "5px"
    },
    searchContainer: {
        marginTop: 4,
        marginBottom: 4,
    },
    logContainer: {
        height: '50vh',
        width: '100%',
        overflowY: 'auto',
        backgroundColor: '#1e1e1e',
        color: '#d4d4d4',
        padding: '10px',
        fontFamily: 'monospace',
        whiteSpace: 'pre-wrap'
    },
    logEntry: {
        padding: '5px 0',
        fontSize: "12px",
        marginBottom: "-9px"
    },
    highlighted: {
        backgroundColor: 'yellow'
    },
    searchBar: {
        marginTop: 4,
        marginBottom: 4,
        display: 'flex',
        justifyContent: "flex-end",
    },
    success: {
        color: 'green',
        fontWeight: 'bold',
    },
    error: {
        color: 'red',
        fontWeight: 'bold',
    },
    noResultLabel: {
        marginLeft: theme.spacing(1),
        alignSelf: 'center',
    },
    disabledIcon: {
        color: '#ccc !important', // Grey out the icon when disabled
    },
    holderDiv: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row'
    },
    drawer1: {
        width: drawerWidth,
        flexShrink: 0,
        backgroundColor: '#FF0000',
    },
    ppr: {
        overflow: 'hidden',
        width: drawerWidth,
        marginLeft: '64px',
        backgroundColor: '#FF0000',
    },
    drawerHeader1: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
        marginTop: '50%',
    },
    collapseMainDrawer1: {
        width: 0,
        flexShrink: 0,
      },
}));


export default function BuildDeployLogs( {logType, setIsRecentBatch} ) {

    const classes = useStyles();
    const dispatch = useDispatch()

    const [noLogs, setNoLogs] = useState(false);
    const [noBatches, setNoBatches] = useState(false);
    const [batches, setBatches] = useState([]);
    const [batchLoading, setBatchLoading] = useState(false);
    const [singleLog, setSingleLog] = useState([]);
    const [batchOnFocus, setBatchOnFocus] = useState({});
    const [searchText, setSearchText] = useState('');
    const [searchTextIndex, setSearchTextIndex] = useState(0);
    const [noSearchFound, setNoSearchFound] = useState(false);
    let [logFetchCounter, setLogFetchCounter] = useState(0);
    const [logLoadInProgress, setLogLoadInProgress] = useState(false);
    const [recentBatch, setRecentBatch] = useState(null);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const drawerContainerRef = useRef(null); // Reference for container


    useEffect(() => {
        getBatches()
    },[])

    useEffect(() => {
        if(setIsRecentBatch != undefined && batchOnFocus?._id != undefined &&  recentBatch != null && recentBatch != undefined  &&  recentBatch?._id != undefined){
            if(setIsRecentBatch != undefined && batchOnFocus?._id != recentBatch?._id) setIsRecentBatch(false);
            else setIsRecentBatch(true); 
        }
               
    },[batchOnFocus])

    const toggleSidebar = () => {
        setIsCollapsed(prev => !prev);
    };

    /** Get build or deploy batches */
    const getBatches = async () => {

        setBatchLoading(true)
        const url = logType == 'build' ? 'getBuildBatches' : 'getDeployBatches'
        const response = await dispatch(invokeGetService(url,[]))
        setBatchLoading(false)
        setBatches(response.batches)

        /** For no batches alert */
        if(response.batches.length == 0) {
            setNoBatches(true)
        }else{
            setNoBatches(false)
        }

        const defaultBatch = findDefaultBatchToLoad(response.batches)
        const latestBatch = getLatestRecord(response.batches)
        setRecentBatch(latestBatch)
        if(setIsRecentBatch != undefined && latestBatch != null && defaultBatch != null && defaultBatch != undefined && latestBatch != undefined){
            if(defaultBatch._id != latestBatch?._id ) setIsRecentBatch(false);
            else setIsRecentBatch(true)
        }
        

        setBatchOnFocus(defaultBatch)
        console.log({defaultBatch})

        if(defaultBatch != null) {
            fetchLogsForBatch(defaultBatch._id)
        }
    }

    /** Find default batch to load */
    const findDefaultBatchToLoad = (batches) => {
        if( batches.length == 0 ) {
            return null
        }

        return batches[0]
    }

    const getLatestRecord = (batches) =>  {
        if (!batches || batches.length === 0) return null;
    
        return batches.reduce((latest, record) => 
            new Date(record.createdAt) > new Date(latest.createdAt) ? record : latest
        );
    }

    /** Fetch log for a batch */
    const fetchLogsForBatch = async (batchID, noReload) => {

        if(noReload === undefined)
            setLogLoadInProgress(true)

        const response = await dispatch(invokeGetService('getBuildDeployLogs', [batchID, logType]))
        console.log('autolog returned', response)
        setBatches(response.allBatches)
        setSingleLog(response.logs)
        setLogLoadInProgress(false)

        if(response?.batch?.status == 'running') {
            console.log({logFetchCounter})
            if(logFetchCounter < 70) {
                setLogFetchCounter(logFetchCounter++)
                setTimeout(function(){
                    fetchLogsForBatch(batchID, true)
                },2500)
            } else {
                dispatch(handleSnackBar({ open: true, message: 'There seems to be an issue in getting the status', severity: "error" }));
            }            
        }

        autoScroll()
    }
    


    const startBuild = () => {
        dispatch(invokeV1GetService('blueprintBuild',[])).then(res => {
            //dispatch(handleSnackBar({ open: true, message: 'Build initiated', severity: "info" }));
            getBatches()
            const recentBatch = findDefaultBatchToLoad(batches)
    
            if(recentBatch != null) {
                fetchLogsForBatch(recentBatch._id)
            }
         })
       
    }


    /** Status icons component */
    const StatusIcon = ({status}) => {

        const iconStyle = { fontSize: '16px' };
        switch (status) {
            case 'running':
                return <CircularProgress size={16} />;
            case 'completed':
                return <CheckCircle style={{ ...iconStyle, color: 'green' }} />;
            case 'failed':
                return <CancelOutlinedIcon style={{ ...iconStyle, color: 'red' }} />;
            default:
                return null;
        } 
    }


    /** Scroll to the bottom of log container */
    const autoScroll = () => {

        const div = document.getElementById('buildDeployLogContainer');
        if(div != null){
            div.scrollTop = div.scrollHeight;
        }
    }

    /** Single log line */
    const SingleLogLine = ({log}) => {

        autoScroll()

        if( log?.log === undefined)
            return <p>Something wrong with this log</p>

        if( log.log.includes('(OK)'))
            return <p style={{color:'green'}}>${log.log}</p>

        if( log.log.includes('(INFO)'))
            return <p style={{color:'#a09de5'}}>${log.log}</p>

        if( log.log.includes('(WARNING)'))
            return <p style={{color:'yellow'}}>${log.log}</p>

        if( log.log.includes('(ERROR)'))
            return <p style={{color:'red'}}>${log.log}</p>

        return <p>{log.log}</p>
    }
    

    return (
        <Grid container direction={"row"} spacing={3} ref={drawerContainerRef}>
            { noBatches && 
            <Grid item xs={12} style={{ height: "50vh", border: '1px solid #ccc', padding: 15,  }}>
                {logType === 'build' && <Alert style={{height: '100px', display: 'flex',  alignItems: 'center'}} severity="warning">No { logType === 'build' ? 'build': 'deploy' } logs found. <Button onClick={startBuild} style={{textTransform: 'capitalize'}}  >Build Now</Button></Alert>}
                {logType === 'deploy' && <Alert style={{height: '100px', display: 'flex',  alignItems: 'center'}} severity="warning">No { logType === 'build' ? 'build': 'deploy' } logs found. </Alert>}
            </Grid>}

            { noLogs && 
            <Grid item xs={12} style={{ height: "50vh", border: '1px solid #ccc', padding: 15 }}>
                <Alert severity="warning">No { logType === 'build' ? 'build': 'deploy' } logs found. </Alert>
            </Grid>}
           

            {!isCollapsed && !noBatches && 
            <Grid id={"left_panel"} item xs={3} style={{ transition: "width 0.3s ease", minHeight:"400px" }}>
                <Paper
                    elevation={3}
                    style={{
                        width: "100%",
                        height: "100%",
                        background: "white",
                        zIndex: 10,
                        padding: "16px",
                        boxShadow: "1px 0px 0px rgba(0,0,0,0.2)",
                        position: "relative", // Needed for absolute positioning of the button
                        display: "flex",
                        flexDirection: "column",
                        alignItems: isCollapsed ? "center" : "flex-start",
                        justifyContent: "space-between",
                    }}
                >

                    <List id="logsList">

                        {!noBatches && logType === 'build' && 
                        <ListItem>
                            <Button id="trigger-new-build" style={{ textTransform: 'capitalize' }} variant='contained' color="primary" onClick={startBuild}>Trigger New Build</Button>
                        </ListItem>}

                        {batchLoading && 
                        <ListItem>
                            <Tooltip title="Status Tooltip" arrow>
                                <ListItemIcon style={{ minWidth: '30px' }}>
                                    <CircularProgress size={16} color="secondary" id={'icon-for-progress'} />
                                </ListItemIcon>
                            </Tooltip>
                            <ListItemText primary={`Loading ${logType} batches`} />
                        </ListItem>}

                        {batches.sort((a, b) => a.label < b.label).map(batch => <ListItem style={{ cursor: 'pointer', color: batchOnFocus?._id == batch._id ? 'blue' : 'black' }} onClick={() => { setBatchOnFocus(batch); fetchLogsForBatch(batch._id) }}>
                            <Tooltip title={batch.label} arrow>
                                <ListItemIcon style={{ minWidth: '30px' }}>
                                    <StatusIcon status={batch.status} />
                                </ListItemIcon>
                            </Tooltip>
                            <ListItemText primary={batch.label} />
                        </ListItem>)}
                    </List>
                    <Tooltip title="Collapse Drawer" arrow>
                        <IconButton
                            onClick={toggleSidebar}
                            style={{
                                position: "absolute",
                                top: "50%",
                                right: "-20px",
                                transform: "translateY(-50%)",
                                // background: "white",
                                border: "1px solid #ccc",
                                boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
                                background: "#e0e0e0", // Light gray background
                                width: "40px", // Smaller size
                                height: "40px",
                                minWidth: "unset"
                            }}
                        >
                            <ChevronLeftIcon />
                        </IconButton>
                    </Tooltip>
                </Paper>
            </Grid> }         

            {singleLog.length > 0 &&
             <Grid id={"right_panel"} item xs={isCollapsed ? 12 : 9} style={{ transition: "width 0.3s ease" }}>
                
                
                <Grid item xs={12} className={classes.topHeading}>
                    <Grid item className={classes.labelDivStyle}>
                        { batchOnFocus != null && <Typography variant='h6'>
                            { batchOnFocus.label }
                        </Typography> }
                    </Grid>
                    
                </Grid>
                <Grid item xs={12} className={classes.searchBar}>

                </Grid>
                
                {!logLoadInProgress && <Grid item xs={12}>
                    
                    <div className={classes.logContainer} id={"buildDeployLogContainer"}>
                        {isCollapsed && (
                            <Tooltip title="Expand Drawer" arrow>
                            <IconButton
                                onClick={toggleSidebar}
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "-15px", // Left border of logContainer
                                    transform: "translateY(-50%)",
                                    // background: "white",
                                    border: "1px solid #ccc",
                                    boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
                                    zIndex: 10,
                                    background: "#e0e0e0", // Light gray background
                                    width: "40px", // Smaller size
                                    height: "40px",
                                    minWidth: "unset"
                                }}
                            >
                                <ChevronRightIcon />
                            </IconButton>
                            </Tooltip>
                        )}
                        <div id={'buildDeployLogContainerInnerDiv'} className={`${classes.logEntry} log-entry ${classes.holderDiv}`}>
                           { singleLog.map( log => <SingleLogLine log={log} /> )}
                        </div>
                    </div>
                </Grid>}

                {logLoadInProgress && <Grid item xs={12} className={classes.logContainer}>Loading the logs..</Grid>}
            </Grid>}


        </Grid >
    )
}
